import { useState, useEffect } from 'react'

export const useDomDimensions = () => {
	const [availableContentHeight, setAvailableContentHeight] = useState(0)

	// This is fragile, but it gives us the available height for the main content area within FA pages.
	const calcAvailableHeight = () => {
		const header = document.getElementsByTagName('header')[0]?.getBoundingClientRect()?.height || 0
		const crumbs = document.getElementById('crumbs')?.getBoundingClientRect()?.height || 0
		setAvailableContentHeight(window.innerHeight - header - crumbs)
	}
	useEffect(() => {
		calcAvailableHeight()
		window.addEventListener('resize', calcAvailableHeight)
		window.addEventListener('load', calcAvailableHeight)
		return () => {
			window.removeEventListener('resize', calcAvailableHeight)
			window.removeEventListener('load', calcAvailableHeight)
		}
	}, [])

	return { availableContentHeight }
}

export default useDomDimensions
